import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isEqual } from 'lodash';
import { isEmpty } from '../../utils/helper';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TodoItem from '../../v2/molecules/Todo';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import { TODO_ACTIONS } from './todo.constants';
import { getManipulatedTodosForApi } from './Todo.helpers';
export default class Todo extends Component {
  constructor() {
    super();
    this.setTodo = todo => {
      this.setState({
        todo
      });
    };
    this.addOrEditTodo = (todo, idKey, itemIdKey) => {
      const {
        addTodo,
        addNewTodo,
        apiBaseUrl
      } = this.props;
      const {
        todo: todoFromState
      } = this.state;
      if (isEmpty(todo.title)) {
        return;
      }
      if (isEmpty(todo.id)) {
        addTodo(apiBaseUrl, {
          [TODO_ACTIONS.TODO_ADD]: [getManipulatedTodosForApi(todo, idKey, itemIdKey)]
        }, TODO_ACTIONS.TODO_ADD, () => {
          addNewTodo(false);
        });
      } else {
        addTodo(apiBaseUrl, {
          [TODO_ACTIONS.TODO_UPDATE]: getManipulatedTodosForApi(_objectSpread(_objectSpread({}, todoFromState), todo), idKey, itemIdKey)
        }, TODO_ACTIONS.TODO_UPDATE);
      }
    };
    this.deleteTodo = () => {
      const {
        addTodo,
        addNewTodo,
        apiBaseUrl
      } = this.props;
      const {
        todo: todoFromState
      } = this.state;
      if (!isEmpty(todoFromState === null || todoFromState === void 0 ? void 0 : todoFromState.id)) {
        addTodo(apiBaseUrl, {
          [TODO_ACTIONS.TODO_DELETE]: [todoFromState.id]
        }, TODO_ACTIONS.TODO_DELETE);
      } else {
        addNewTodo(false);
      }
    };
    this.state = {
      todo: EMPTY_OBJECT
    };
  }
  componentDidMount() {
    const {
      todo
    } = this.props;
    if (!isEmpty(todo)) {
      this.setTodo(todo);
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const {
      todo: prevTodo
    } = prevState;
    const {
      todo
    } = this.props;
    if (todo !== null && todo !== void 0 && todo.id && !isEqual(todo, prevTodo)) {
      this.setTodo(todo);
    }
  }
  render() {
    const {
      todo: todoFromState
    } = this.state;
    return /*#__PURE__*/React.createElement(TodoItem, {
      showColor: true,
      showHeader: true,
      event: todoFromState,
      idKey: "id",
      removeEvent: this.deleteTodo,
      updateEvent: this.addOrEditTodo
    });
  }
}
Todo.propTypes = {
  todo: PropTypes.object.isRequired,
  addNewTodo: PropTypes.func.isRequired
};